<template>
  <v-container class="gen-code-page" fluid>
    <v-layout row>
      <v-flex xs12>
        <h1>Tạo Mã Khuyến Mãi</h1>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs12>
        <v-card>
          <v-card-title class="card-title-flex">
            <span>Tạo Mã Khuyến Mãi</span>
          </v-card-title>
          <v-card-text>
            <!-- Username and Password Input -->
            <v-layout row class="mb-3">
              <v-flex xs12 sm4>
                <v-text-field
                  v-model="authUsername"
                  label="Username"
                  name="username"
                  prepend-icon="person"
                  type="text"
                  outline
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row class="mb-3">
              <v-flex xs12 sm4>
                <v-text-field
                  v-model="authPassword"
                  label="Password"
                  name="password"
                  prepend-icon="lock"
                  type="password"
                  outline
                ></v-text-field>
              </v-flex>
            </v-layout>

            <!-- Quantity Input -->
            <v-layout row class="mb-3">
              <v-flex xs12 sm4>
                <v-text-field
                  v-model.number="quantity"
                  label="Quantity"
                  type="number"
                  prepend-icon="mdi-help-circle-outline"
                  min="0"
                  outline
                ></v-text-field>
              </v-flex>
            </v-layout>

            <!-- Package rows with VIP days selection -->
            <div v-for="(pkg, index) in packages" :key="index" class="package-row">
              <v-layout row align-center class="mb-3">
                <!-- Select checkbox and Package name -->
                <v-flex xs12 sm4 class="d-flex align-center">
                  <v-checkbox 
                    v-model="pkg.isSelected"
                    class="ma-0 pa-0"
                    style="width: auto; margin-right: 10px;"
                  ></v-checkbox>
                  <span class="section-title">{{ pkg.name }}</span>
                </v-flex>

                <!-- VIP days radio buttons (shown when selected) -->
                <v-flex xs12 sm8 v-if="pkg.isSelected">
                  <v-radio-group v-model="pkg.selectedDays" row>
                    <v-radio 
                      v-for="days in vipDays" 
                      :key="days" 
                      :label="`${days} ngày`" 
                      :value="days"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
            </div>

            <!-- Gencode Button -->
            <v-layout row class="mt-4">
              <v-flex xs12>
                <v-btn color="primary" large @click="generateCode">
                  Gencode
                </v-btn>
              </v-flex>
            </v-layout>

            <!-- Code List Display -->
            <v-layout row v-if="codeList" class="mt-4">
              <v-flex xs12>
                <v-card>
                  <v-card-title class="card-title-flex">
                    <span>Danh Sách Mã Được Tạo</span>
                    <v-btn 
                      color="primary" 
                      @click="copyToClipboard"
                      style="width: 122px; height: 44px; font-size: 14px;"
                    >
                      Copy
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-textarea
                      v-model="codesToShow"
                      label="Mã Khuyến Mãi"
                      readonly
                      outline
                      rows="10"
                    ></v-textarea>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios';
import { message } from '@/shared/message';
import { de } from 'date-fns/locale';

export default {
  name: 'GenCodePage',
  data() {
    return {
      // Authentication fields
      authUsername: '',
      authPassword: '',
      // Gen Code fields
      quantity: null,
      codeList: null,
      codesToShow: null,
      packages: [
        { name: 'babilala', isSelected: false, selectedDays: null },
        { name: 'babilala_maths', isSelected: false, selectedDays: null },
        { name: 'babi_class', isSelected: false, selectedDays: null },
      ],
      vipDays: [3, 7, 30, 90, 365],
    }
  },
  beforeDestroy(){
      this.authUsername = '';
      this.authPassword = '';
      this.quantity = null;
      this.codeList = null;
      this.codesToShow = null;
      this.packages = [
        { name: 'babilala', isSelected: false, selectedDays: null },
        { name: 'babilala_maths', isSelected: false, selectedDays: null },
        { name: 'babi_class', isSelected: false, selectedDays: null }
      ];
  },
  methods: {
    getProduct() {
      const domain = window.location.hostname;
      return domain.includes("lms-edusmart.") ? "EDUSMART" : "BABILALA";
    },

    copyToClipboard() {
      if (!this.codeList) {
        message.error('Không có mã để sao chép');
        return;
      }
      
      navigator.clipboard.writeText(this.codeList)
        .then(() => {
          message.success('Sao chép thành công');
        })
        .catch(error => {
          console.error('Lỗi sao chép:', error);
          message.error('Sao chép thất bại');
        });
    },

    generateCode() {
      if (!this.authUsername || !this.authPassword) {
        message.error('Vui lòng nhập username và password');
        return;
      }

      if (!this.quantity || this.quantity <= 0) {
        message.error('Vui lòng nhập số lượng hợp lệ');
        return;
      }

      const selectedPackages = this.packages.filter(pkg => pkg.isSelected)
      if (selectedPackages.length === 0) {
        message.error('Vui lòng chọn ít nhất một gói');
        return;
      }

      const unselectedDays = selectedPackages.filter(pkg => !pkg.selectedDays)
      if (unselectedDays.length > 0) {
        message.error('Vui lòng chọn số ngày VIP cho tất cả các gói được chọn');
        return;
      }

      // Tạo json_data từ packages được chọn
      const jsonData = {}
      selectedPackages.forEach(pkg => {
        jsonData[pkg.name] = {
          type: 1,
          days: pkg.selectedDays,
          package_id: 1,
          level: '1,2,3'
        }
      })

      // Gửi API request với username và password
      const formData = new FormData()
      formData.append('phone', '')
      formData.append('number', this.quantity)
      formData.append('json_data', JSON.stringify(jsonData))
      formData.append('username', this.authUsername)
      formData.append('password', this.authPassword)
      formData.append('product', this.getProduct())

      axios.post(`${process.env.VUE_APP_API_URL}/api/genCodesProduction`, formData)
        .then(response => {
          if (response?.resultCode === 1) {
            // Thành công
            this.codeList = response?.code
            // Xử lý codesToShow: bỏ dấu ';' và hiển thị từng dòng
            this.codesToShow = this.codeList
              .split(';')
              .filter(code => code.trim() !== '')
              .join('\n')
            console.log(response);
            message.success(response?.message || "Tạo mã khuyến mãi thành công");
          } else {
            // Thất bại
            this.codeList = null
            this.codesToShow = null
            console.log(response);
            message.error(response?.message || 'Tạo mã khuyến mãi thất bại');
          }
        })
        .catch(error => {
          this.codeList = null
          this.codesToShow = null
          console.log(error);
          message.error('Tạo mã khuyến mãi thất bại: ' + error.message);
        })
    }
  }
}
</script>

<style scoped>
.gen-code-page {
  padding: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.package-row {
  border-bottom: 1px solid #eee;
  padding: 10px 0;
}

.d-flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.mb-3 {
  margin-bottom: 16px;
}

.mb-4 {
  margin-bottom: 24px;
}

.mt-4 {
  margin-top: 24px;
}

.mr-2 {
  margin-right: 8px;
}

.logout-btn {
  padding: 0 16px !important;
  height: 36px !important;
  font-size: 14px !important;
  flex-shrink: 0 !important;
}

.card-title-flex {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
}
</style>
